module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_6.f6ce4607.png";